<template>
  <div class="custom-margin-full-page">
    <v-card class="mx-8 px-10 py-6">
      <v-row>
        <v-col class="custom-card-subscription" v-for="subscription in subscriptions" :key="subscription.id" cols="4">
          <v-row>
            <v-col cols="6">
              <h4>
                {{ subscription.title }}
              </h4>
              <br>
              <p v-html="subscription.subtitle">
              </p>

              قیمت‌:
              <del v-if="subscription.show_price && subscription.show_price != '0'">
                {{ subscription.show_price }} تومان
              </del>
              &nbsp;
              <span>
                      {{ subscription.price }} تومان
          </span>
              <br>
              مدت زمان اعتبار :
              {{ subscription.duration }}
              روز
              <br>
              <v-btn block color="#1ab69d" class="white--text mt-10 normal-button"
                     @click="getCourseIds(subscription.id,subscription.price)">
                خرید اشتراک
              </v-btn>
            </v-col>
            <v-col cols="6">
              <img :src="subscription.cover" alt="cover">
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-card>
    <v-dialog v-model="depositDialog" width="30%">
      <v-card>
        <v-card-actions>
          <v-icon color="error" @click="depositDialog = false">mdi-close</v-icon>
        </v-card-actions>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              موجودی کیف پول کم است .
            </v-col>
            <v-col cols="12" class="px-16">
              <v-text-field
                  color="black"
                  hint="به تومان وارد شود."
                  v-model="formattedAmount"
                  label="مقدار مورد نیاز برای پرداخت (می توانید این مقدار را ویرایش کنید)"></v-text-field>
            </v-col>
            <v-col cols="12" class="px-16">
              <v-btn block color="#1ab69d" @click="deposit()" style="letter-spacing: normal" class="white--text">انتقال
                به
                درگاه پرداخت
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="selectCourseDialog" width="30%">
      <v-card>
        <v-card-actions>
          <v-icon color="error" @click="selectCourseDialog = false">mdi-close</v-icon>
        </v-card-actions>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              دوره مورد نظر را انتخاب کنید.
              (چنانچه دوره مورد نظر را در این لیست نمی بینید اشتراک اشتباهی را انتخاب کرده اید)
            </v-col>
            <v-col cols="6" style="cursor: pointer;" v-for="course in courses" :key="course.id"
                   @click="selectCourse(course.id)">
              <v-card elevation="0" class="course-card pa-6">
                <v-card-title class="text-center white-background">
                  {{ course.title }}
                </v-card-title>
                <v-card-text class="white-background">
                  <v-row>
                    <v-col cols="12">
                      <img class="course-cover" width="200px" height="200px" :src="course.cover_file"
                           :alt="course.title">
                    </v-col>
                    <v-col cols="12" v-if="course.sub_title">
                      {{ course.sub_title }}
                    </v-col>
                    <v-col cols="12" v-if="course.description">
                      {{ course.description }}
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  name: "SubscriptionDesktop",
  data() {
    return {
      subscriptions: [],
      amount: null,
      description: null,
      depositDialog: false,
      selectedSubscriptionId: null,
      selectedSubscriptionPrice: null,
      courses: [],
      selectCourseDialog: false,
      selectedCourseId: null
    }
  },
  computed: {
    formattedAmount: {
      get() {
        // Format the amount as a string with commas every 3 digits
        if (this.amount === null || this.amount === "") return "";
        return this.amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      },
      set(value) {
        // Strip commas and assign the number back to amount
        this.amount = value.replace(/,/g, "");
      },
    },
  },
  methods: {
    deposit() {
      window.axios.post('/finance/wallet/charge', {
        amount: this.amount,
        description: this.description,
        section: 'subscription',
        subscription_id: this.selectedSubscriptionId,
        course_id: this.selectedCourseId
      }).then((res) => {
        let url = JSON.parse(res.data.data)
        window.location.href = url.action
      })
    },
    getSubscriptions() {
      window.axios.get('student/subscriptions/index').then((res) => {
        this.subscriptions = res.data.data
      })
    },
    purchase() {
      window.axios.post('student/subscriptions/buy', {
        subscription_id: this.selectedSubscriptionId,
        course_id: this.selectedCourseId,
      }).then((res) => {
        if (res.data.data.status) {
          window.location.reload();
        } else {
          this.amount = this.selectedSubscriptionPrice - this.$store.state.user.wallet.value
          let self = this
          window.setTimeout(function () {
            self.depositDialog = true
          }, 500)
        }
      })
    },
    selectCourse(courseId) {
      this.selectedCourseId = courseId
      this.selectCourseDialog = false;
      this.purchase()
    },
    getCourseIds(subscriptionId, subscriptionPrice) {
      window.axios.get(`student/subscriptions/check/courses/${subscriptionId}`, {
        subscription_id: subscriptionId
      }).then((res) => {
        this.selectedSubscriptionId = subscriptionId
        this.courses = res.data.data
        this.selectedSubscriptionPrice = subscriptionPrice
        this.selectCourseDialog = true
      })
    }
  },
  mounted() {
    this.getSubscriptions()
  }
}
</script>

<style scoped>
.custom-margin-full-page {
  margin: 5vh 6vw 0 2vw;
}

.custom-card-subscription {
  background-color: whitesmoke !important;
  border-radius: 20px !important;
  margin: 10px !important;
}

.normal-button {
  letter-spacing: normal !important;
}
</style>